export interface IFloorArea {
  id: string;
  name: string;
  group_id: string;
}

export class FloorAreaDTO implements IFloorArea {
  id: string;
  name: string;
  group_id: string;
}

export default class FloorArea extends FloorAreaDTO {
  constructor(dto?: FloorAreaDTO) {
    super();
    if (dto) {
      Object.assign(this, dto);
    } else {
      this.new();
    }
  }

  public new() {
    Object.assign(this, {
      id: null,
      name: "",
      group_id: "",
    });
  }
}
